import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TextField, InputAdornment, IconButton } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import InputMask from 'react-input-mask'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { useController } from 'react-hook-form'

export default function Phone({ control, ...passThroughProps }) {
  const defaultValue = useCurrentUserProp('phone') || ''
  const [phone, setPhone] = useState(defaultValue)
  const { field, fieldState: { error, invalid } } = useController({
    name: 'phone',
    defaultValue,
    control,
    rules: { required: { value: true, message: 'Required' } }
  })

  return (
    <InputMask
      {...field}
      mask='(999) 999-9999'
    >
      {() => (
        <TextField
          label='Phone'
          type='tel'
          helperText={error?.message || 'Optional'}
          error={invalid}
          InputProps={{ endAdornment: !!phone ? <ClearInput reset={() => { setPhone('') }}  /> : null }}
          { ...passThroughProps }
        />
      )}
    </InputMask>
  )
}

function ClearInput({ reset }) {
  return (
    <InputAdornment position='end'>
      <IconButton onClick={reset}><CancelIcon /></IconButton>
    </InputAdornment>
  )
}

ClearInput.propTypes = {
  reset: PropTypes.func.isRequired
}
